import { Actions } from './qualificationActions';

/**
 * Etat initial
 */
const initialState = {
    qualifications: {
        items: [],
        isLoading: false
    },
    qualificationsFiltre: {
        items: [],
        isLoading: false
    }
};

/**
 * Reducer pour les qualifications
 */
const reducer = (state = initialState, action) => {

    switch (action.type) {
        // Fetch Qualifications.
        case Actions.FETCH_QUALIFICATIONS_REQUEST:
            return {
                ...state,
                qualifications: { ...state.qualifications, isLoading: true }
            };
        case Actions.FETCH_QUALIFICATIONS_SUCCESS:
            return {
                ...state,
                qualifications: { items: [...action.qualifications], isLoading: false }
            };
        case Actions.FETCH_QUALIFICATIONS_FAILURE:
            return {
                ...state,
                qualifications: { ...state.qualifications, isLoading: false, error: action.error }
            };
        // Fetch QualificationsFiltre.
        case Actions.FETCH_QUALIFICATIONS_FILTRE_REQUEST:
            return {
                ...state,
                qualificationsFiltre: { ...state.qualificationsFiltre, isLoading: true }
            };
        case Actions.FETCH_QUALIFICATIONS_FILTRE_SUCCESS:
            return {
                ...state,
                qualificationsFiltre: { items: [...action.qualifications], isLoading: false }
            };
        case Actions.FETCH_QUALIFICATIONS_FILTRE_FAILURE:
            return {
                ...state,
                qualificationsFiltre: { ...state.qualificationsFiltre, isLoading: false, error: action.error }
            };

        default:
    }

    return state;
};

export default reducer;